import { Component, OnInit } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import gql from 'graphql-tag';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { StaticModuleConsts } from '../../contants';
import { Title } from '@angular/platform-browser';
@Component({
    selector: 'terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss', '../faq/faq.component.scss'],
    standalone: false
})
export class TermsComponent implements OnInit {
  firstSection: any;
  itemsSection: any;
  TERMS_OF_USE_QUERY = gql`
  query  {
    termsOfUses{
      id
      heading
	  id
      content {
        raw
        
      }
    }
}
`;
private query: QueryRef<any>;
  constructor(private apollo: Apollo, private statePersist: StatePersistService,
    private titleService: Title) { }

  ngOnInit(): void {
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
    this.titleService.setTitle(StaticModuleConsts.TERMS_OF_USE_PAGE_TITLE);
    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.removeLocalStorage('product_data')
    this.query = this.apollo.watchQuery({
      query: this.TERMS_OF_USE_QUERY,
      variables: {}
    });
    this.query.valueChanges.subscribe(result => {
      this.firstSection = result.data.termsOfUses
      window.scroll({ 
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    });
  }

}
